import { render, staticRenderFns } from "./DashboardObjetivos.vue?vue&type=template&id=0a1ba960&scoped=true"
import script from "./DashboardObjetivos.vue?vue&type=script&lang=js"
export * from "./DashboardObjetivos.vue?vue&type=script&lang=js"
import style0 from "./DashboardObjetivos.vue?vue&type=style&index=0&id=0a1ba960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1ba960",
  null
  
)

export default component.exports